import React from 'react';
import Card from 'lib/components/Card/Card';
import { Permissions } from 'lib/permissions/roles';
import { ReportHeader } from '../components/ReportHeader';
import ProductRevenueBarChart from '../components/ProductRevenueBarChart';
import ProductCategoryCharts from '../components/ProductCategoryCharts';

export function ProductsTab() {
  return (
    <Card>
      <ReportHeader
        title={'Products'}
        subtitle={
          'View publisher revenue performance, assuming full collection, on orders with a last publication date in the selected range.'
        }
        subtitleToolTip={`Revenue displayed in this report is net of Column fees and assumes full publisher collection on invoices. To view unpaid overdue invoices, navigate to the Accounting Tab. To view amounts collected in Column and paid out to the publisher, navigate to Settings > My Organization > Payouts.`}
        permission={Permissions.PAYMENTS_REPORT}
      />
      <div className="p-6">
        <div className="flex flex-col gap-8">
          <ProductRevenueBarChart />
          <ProductCategoryCharts />
        </div>
      </div>
    </Card>
  );
}
